(() => {
  angular
    .module('gm.common.directives')
    .directive('gmLineInputPassword', gmLineInputPasswordDirective);

  function gmLineInputPasswordDirective() {
    'ngInject';

    return {
      require: 'ngModel',
      restrict: 'E',
      scope: {},
      templateUrl: 'modules/common/directives/line-input-password/line-input-password.html',
      transclude: true,

      link(scope, _element, _attrs, ctrl) {
        scope.value = '';

        scope.$watch(() => ctrl.$viewValue, (newValue) => {
          scope.value = newValue;
        });
        scope.$watch('lineInputPassword.$error.strength', (strengthValidity) => {
          ctrl.$setValidity('strength', !strengthValidity);
        });
        scope.$watch('value', value => ctrl.$setViewValue(value));
      },
    };
  }
})();
